export { MerchantLogo } from './MerchantLogo';
